import { render, staticRenderFns } from "./CTableRow.vue?vue&type=template&id=48cad794&scoped=true&"
import script from "./CTableRow.vue?vue&type=script&lang=js&"
export * from "./CTableRow.vue?vue&type=script&lang=js&"
import style0 from "./CTableRow.vue?vue&type=style&index=0&id=48cad794&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cad794",
  null
  
)

export default component.exports